export default {
  common: {
    webName: 'MiraStudent',
    login: 'Login',
    startImmediately: 'Start Now',
    delete: 'Delete',
    experienceClass: 'Trial Class',
    enter: 'Please enter',
    cancel: 'Cancel',
    confirm: 'Confirm',
    select: 'Please select',
    operationSuccessful: 'Operation successful',
    upload: 'Upload',
    classID: 'Class ID',
    wantToDelete: 'Are you sure you want to delete?',
    studyReport: 'Study Report',
    submit: 'Submit',
    userCenter: 'User Center',
    setting: 'Settings',
    updataSuccess: 'Submitted successfully, awaiting review',
    balance: 'Mira Balance',
    simplifiedChinese: 'Simplified Chinese',
    traditionalChinese: 'Traditional Chinese',
    English: 'English',
    Japanese: 'Japanese',
    Korean: 'Korean',
    courseCancelled: 'Class cancelled',
    contactTeacher: 'Contact Teacher',
    numberClass: '{num} classes',
    endTime: 'Expiry time',
    setSuccess: 'Setting successful',
    studentsUpload: 'Student Upload',
    teacherUpload: 'Teacher Upload',
    hour: 'hour',
    class: 'class',
    fivetyminutes: '50 minutes'
  },
  headers: {
    searchTeachers: 'Search Teachers',
    recommendTeachers: 'Recommended Teachers',
    becomeTeacher: 'Become a Teacher',
    teacherPortal: 'Teacher Portal',
    balance: 'Mira Balance'
  },
  footers: {
    about: 'About',
    pavilionToUs: 'About Us',
    used: 'How to Use',
    becomeTeacher: 'Become a Teacher',
    naturalResources: 'Resources',
    study: 'Study Column',
    help: 'Help',
    contactUs: 'Contact Us',
    questions: 'FAQ',
    pay: 'Payment Methods',
    refund: 'Refund Policy',
    socialize: 'MiraStudent Social'
  },
  mainIndex: {
    titleOne: '1-on-1 Professional Teachers',
    titleTwo: 'Personalized Teaching 路 Interactive Focused Learning',
    titleThree: 'Online Tutoring Platform',
    titleFour: 'MiraStudent is an online tutoring platform that breaks geographical and time barriers through educational technology',
    titleFive: 'Allowing students to receive professional guidance at home, saving time, improving learning efficiency and ability, and easily handling exams!',
    titleSubject: 'Popular Tutoring Subjects',
    viewMore: 'View More',
    invitationalEducation: 'Find teachers who can inspire your learning potential',
    introduce: 'We have certified teachers, subject specialists, language experts, and professionals to help you with various learning needs',
    reasonForSelection: 'Why Choose MiraStudent',
    reasonTitleOne: 'High-quality Subject-specific Teachers',
    reasonContentOne: 'All teachers are strictly screened with verified identities, backgrounds, and qualifications',
    reasonTitleTwo: 'Flexible and Easy Learning',
    reasonContentTwo: 'Break traditional learning frameworks and attend classes online anytime, anywhere',
    reasonTitlethree: 'Customized Courses',
    reasonContentThree: 'One-on-one professional teachers create unique courses tailored to you',
    reasonTitlefour: 'Fair and Reasonable Pricing',
    reasonContentFour: 'Teachers set their own prices - choose suitable classes within your budget',
    classProcess: 'Class Process',
    processOne_1: 'Find suitable teachers',
    processOne_2: 'Select teachers based on their profiles, introduction videos, and student reviews',
    processOne_3: 'Communicate with teachers and purchase trial classes to test suitability',
    processTwo_1: 'Schedule Classes',
    processTwo_2: 'After purchase, book available times on the teacher\'s calendar for confirmation',
    processTwo_3: 'Students can reschedule or cancel 24 hours before class',
    processThree_1: 'Start Learning',
    processThree_2: 'Download teacher\'s notes (if available) before class. Join class via VOOV video classroom. Upload completed assignments after class',
    obtainIncome: 'Earn income by sharing your expertise with students',
    onlineTeaching: 'Register to start teaching online with MiraStudent',
    evaluate: 'Hear from MiraStudent learners'
  },
  cashDesk: {
    cashRegister: 'Checkout',
    goods: 'Product',
    subject: 'Subject',
    category: 'Category',
    time: 'Time',
    classNum: 'Classes',
    total: 'Subtotal',
    single: 'Single class',
    discount: 'Discount',
    selectCoupon: 'Select coupon',
    noCoupon: 'No coupon',
    couponDiscount: 'Trial class discount',
    totalCount: 'Total',
    paymentMethod: 'Payment Method',
    payment: 'Use Mira Coins',
    balance: 'Balance',
    noBalance: 'Insufficient balance, click to top up',
    pay: 'Confirm and Pay',
    purchaseSuccessful: 'Purchase Successful'
  },
  forStudy: {
    skipQuestion: 'Skip question',
    chooseMentor: 'Choose teacher yourself',
    studyFor: 'What do you want to learn?',
    budget: 'Budget per class?',
    country: 'Your country/region?',
    classTime: 'Class time?',
    mentorLevel: 'Teacher level?',
    motherTongue: 'Native speaker?',
    masterLanguage: 'Languages spoken?',
    weekMon_weekFri: 'Mon~Fri',
    weekend: 'Sat, Sun',
    anyTime: 'Any time'
  },
  forClassIndex: {
    languageLevel: 'Language Level',
    onlineTeacher: 'Online English Teachers',
    seacher: 'Search teacher name or keyword',
    class: 'Class',
    pleaseSelect: 'Please select',
    budget: 'Learning budget per class',
    country: 'From country/region',
    classTime: 'Class time',
    schedulingPeriod: 'Scheduling period',
    mentorLevel: 'Teacher level',
    brfore: 'Before',
    motherTongue: 'Native speaker',
    masterLanguage: 'Languages spoken',
    suitable: 'teachers matching your needs',
    new: 'NEW',
    highQualityMentor: 'Premium Teachers',
    seniorTutor: 'Senior Teacher',
    professionalTeacher: 'Professional Teacher',
    professor: 'Professor',
    speek: 'Speaks',
    learnMore: 'Learn more',
    minute: 'minutes',
    poetryHall: 'Poetry Hall',
    trialClass: 'Book trial class',
    contactMentor: 'Contact Teacher',
    viewClass: 'View full class schedule'
  },
  personalizationTeacher: {
    seacherTeacher: 'Find your personalized teacher',
    hint: 'Answer a few simple questions to help match the most suitable teacher',
    studyFor: 'What is your learning purpose?',
    start: 'Start',
    selectTeacher: 'Choose teacher yourself'
  },
  teacherVue: {
    information: 'About {name}',
    teachingSubjects: 'Teaching Subjects',
    professorlevel: 'Teaching Level',
    highestEducationLevel: 'Highest Education',
    experience: 'Special Education Experience',
    aboutMe: 'About Me',
    videoIntroduction: 'Video Introduction',
    cannotPlay: 'Video not supported',
    classTime: 'Teaching Schedule',
    resume: 'Resume',
    evaluate: 'Reviews',
    myClass: 'My Classes',
    testClassTime: '1 class (25 mins)',
    formalClasses: 'Regular Classes',
    formalClassTime: '{number} classes (50 mins)',
    priceAdjustment: 'Teacher\'s class price will adjust on {time}'
  },
  login: {
    login: 'Login',
    welcome: 'Welcome to MiraStudent!',
    hint: 'By continuing, you agree to MiraStudent Terms of Service and Privacy Policy',
    loginMethod: 'Login with {way}',
    or: 'or',
    email: 'Email',
    emailAccount: 'Your email address',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    forgotPassword: 'Forgot password?',
    rememberMe: 'Remember me',
    toLogin: 'Login',
    noAccount: 'No account yet?',
    register: 'Register',
    editPassword: 'Change Password',
    retry: 'Retry in {countdown} seconds',
    send: 'Send code',
    code: 'Verification code',
    codePlaceholder: 'Enter verification code'
  },
  studentsCom: {
    calendar: 'Calendar',
    month: 'Month',
    week: 'Week',
    reportCourseNotCompleted: 'Report incomplete class',
    situationDescription: 'We\'re sorry your class wasn\'t completed as expected. Please provide details below',
    whyNotCompleted: '*Why wasn\'t your class completed?',
    solution: '*Your proposed solution?',
    explanation: 'Explanation and evidence',
    explanationContent: 'Provide supporting evidence for best results (max 5 images/videos)',
    uploadImage: 'Upload evidence',

    // My Classes
    myClass: 'My Classes',
    bookNewClassroom: 'Book New Class',
    list: 'List',
    waitingClass: 'Upcoming',
    completed: 'Completed',
    pendingConfirmation: 'Pending Confirmation',
    enterClassroom: 'Enter Classroom',
    upcomingCourses: 'Upcoming Classes',
    waitingConfirm: 'Awaiting teacher confirmation',
    waitingConfirmstudent: 'Awaiting student confirmation',
    confirmAfterClass: 'Post-class confirmation needed',
    confirmed: 'Confirmed',

    // My Homework
    myWork: 'My Homework',
    // My Notes
    myNotes: 'My Notes',
    // My Teachers
    myTeacher: 'My Teachers',
    reserve: 'Book',
    chat: 'Chat',
    giveExtra: 'Tip',
    recommendedTeacher: 'Recommended Teachers',
    professionalTeacher: 'Professional Teacher',
    seniorTeacher: 'Senior Teacher',
    myTest: 'My Tests',

    resolved: 'Resolved',
    selectSolutionTip: 'Select agreed solution for student confirmation within 48 hours',
    selectSolution: 'Select resolution',
    selectPlaceholder: 'Select',
    fillRefundAmount: 'Enter refund amount',
    feeDeductionTip: 'Refund amount deducted from class fee before commission',

    teacherEvaluation: 'Teacher Review',
    classSatisfaction: 'Class Satisfaction',
    selectTeachingTraits: 'Select teaching traits for {name}',
    showOnProfileNamed: 'Displayed on teacher profile (named)',
    showOnProfileAnonymous: 'Displayed on teacher profile (anonymous)',
    writeClassExperience: 'Share your class experience',
    classFeedback: 'Feedback for {name}\'s class',

    tradingOrder: 'Transaction Orders',
    completedOrders: 'Completed Orders',
    refundedOrders: 'Refunded Orders',
    transactionTime: 'Transaction Time',
    teacherName: 'Teacher Name',
    courseContent: 'Course Content',
    amount: 'Amount',
    orderNumber: 'Order ID',

    unresolved: 'Unresolved',
    uploadDataDecision: 'Submit evidence for platform decision',
    explanationAndProof: 'Explanation and evidence',
    uploadEvidenceTip: 'Provide supporting evidence for best results'
  },
  userMySetting: {
    setting: 'Settings',
    logOut: 'Logout',
    basicInfo: 'Basic Info',
    photo: 'Photo',
    uploadAvatarTip: 'Upload clear profile photo',
    name: 'Name',
    inputNamePlaceholder: 'Enter name',
    gender: 'Gender',
    selectPlaceholder: 'Select',
    male: 'Male',
    female: 'Female',
    timeZone: 'Time Zone',
    currency: 'Currency',
    birthday: 'Birthday',
    displayLanguage: 'Display Language',
    country: 'Country',
    save: 'Save',
    accountVerification: 'Account Verification',
    email: 'Email',
    inputEmailPlaceholder: 'Enter email',
    sendVerificationEmail: 'Send verification email',
    password: 'Password',
    editPassword: 'Change Password',
    bindApp: 'Link Apps',
    facebook: 'Facebook',
    google: 'Google',
    wechat: 'WeChat',
    clickToBind: 'Click to link',
    unbind: 'Unlink',
    confirmLogout: 'Confirm logout?',
    logoutContent: 'Logout',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  userMyWallet: {
    myWallet: 'My Wallet (Student)',
    recharge: 'Top Up',
    availableBalance: 'Available Balance',
    approximateAmountTip: '*Amounts approximate and subject to exchange rates. All amounts in USD',
    walletTransactionDetails: 'Wallet Transactions',
    time: 'Time',
    item: 'Item',
    amount: 'Amount',
    orderId: 'Order ID',
    classNumber: 'Class ID'
  },
  userCenter: {
    greeting: 'Hello!',
    nickname: 'Nickname',
    todolist: 'Calendar',
    myCoursesPackage: 'My Course Packages',
    myCourses: 'My Courses',
    classBalance: 'Class Balance',
    appointment: 'Book',
    viewClass: 'View Classes',
    myCoupons: 'My Coupons',
    newUserCoupon: 'New user $10 coupon',
    minimumConsumption: 'Minimum spend',
    validTime: 'Validity',
    myHomework: 'My Homework',
    completedHomework: 'completed assignments',
    myTest: 'My Tests',
    noIncompleteTest: 'No pending tests',
    learningReport: 'Learning Report',
    personalizedRecommendation: 'Personalized Recommendations',
    todayHot: 'Trending Today',
    fromUK: 'From UK',
    nativeLanguage: 'Native',
    hourlyCharge: 'Hourly rate',
    ticketPackage: 'Package Deals',
    discount: 'Discount',
    recommendationReason: 'Recommended because',
    bookNow: 'Book Now',
    toDoList: 'To-Do List',
    timeLimitedOffer: 'Limited Time Offer',
    purchase: 'Buy',
    remainingTime: 'Time left',
    teacherAppointmentConfirm: 'Teacher booking confirmation',
    timeZone: 'Time Zone',
    confirm: 'Confirm',
    reject: 'Reject',
    reportContent: 'reports/last 3 months'
  },
  appointment: {
    appointmentCourse: 'Book Class',
    teacher: 'Teacher',
    coursePackage: 'Class Package',
    remainingClasses: 'Remaining classes',
    selectedClasses: 'Selected',
    availableClasses: 'Available',
    contactTool: 'Contact Method',
    selectContactTool: 'Select teacher\'s contact method',
    nextStep: 'Next',
    cancel: 'Cancel',
    confirm: 'Confirm',
    reservationSuccess: 'Booking Successful',
    appointmentClass: 'Classes to book',
    classDate: 'Class Date',
    time: 'Time',
    selectContact: 'Select contact method'
  },
  teacherConfirms: {
    week: 'Week',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    utcTime: '(UTC+08:00)',
    classId: 'Class ID:',
    language: 'Language',
    duration: 'Duration',
    price: 'Price',
    languageCategory: 'Language Category',
    languageType: 'Language Type',
    restTimeNote: 'Some teachers may include 5-minute breaks during class.',
    contactTool: 'Contact Method',
    avatar: 'Avatar Meeting ID',
    password: 'Password',
    teacherEntryTime: 'Teacher entry time:',
    studentEntryTime: 'Student entry time:',
    notes: 'Notes',
    homework: 'Homework',
    test: 'Test',
    uploadHomework: 'Upload Homework',
    uploadTest: 'Upload Test',
    pendingTeacherConfirm: 'Awaiting teacher confirmation',
    yourClassPending: 'Your class awaiting confirmation',
    cancelReschedulePolicy: 'Please read our cancellation and rescheduling policy first',
    pendingConfirm: 'Pending Confirmation',
    classPendingConfirm: 'Class awaiting confirmation',
    pendingClass: 'Upcoming Class',
    classStartOnTime: 'Your class will start at scheduled time',
    classCompletedPendingConfirm: 'Completed - Pending Confirmation',
    confirmWithin3Days: 'Please confirm within 3 days after class, otherwise system will auto-confirm at {time}({timeZone})',
    reportClassNotCompleted: 'If class didn\'t complete as expected, click "Class Not Completed" to report',
    completed: 'Completed',
    rateTeacherWithin3Days: 'Please rate teacher within 3 days after confirmation',
    classCompletedCongrats: 'Congratulations, this class is completed',
    classNotCompleted: 'Class processed',
    waitingTeacherProcess: 'Waiting for teacher to process before {time}({timeZone})',
    classNotCompletedResultConfirm: 'Class incomplete resolution confirmation',
    processWithin48Hours: 'Please process within 48 hours before {time} ({timeZone})',
    teacherSolution: 'Teacher\'s solution:',
    refundAmount: 'Refund amount:',
    agree: 'Agree',
    applyPlatformRuling: 'Request platform arbitration',
    waitingPlatformRuling: 'Waiting for platform decision',
    pleaseWaitPlatform: 'Please wait for platform processing',
    confirmClass: 'Confirm Class',
    cancelClass: 'Cancel Class',
    enterClassroom: 'Enter Classroom',
    interruptNote: 'If interrupted, click again to re-enter',
    accomplishClass: 'Confirm Class Completion',
    classNotAccomplished: 'Class Not Completed',
    rateTeacher: 'Rate Teacher',
    viewEvaluation: 'View Evaluation',
    confirmCancel: 'Confirm cancellation?',
    cancelClassText: 'Cancel Class',
    confirmAction: 'Confirm',
    cancelAction: 'Cancel',
    operationSuccess: 'Operation successful',
    confirmAppointment: 'Confirm booking?',
    confirmAppointmentText: 'Confirm Booking',
    enterClassroomText: 'Enter Classroom',
    confirmCompletion: 'Confirm class completion?',
    confirmCompletionText: 'Confirm Completion',
    confirmDelete: 'Confirm deletion?',
    deleteText: 'Delete',
    confirmAgree: 'Confirm agreement?',
    agreeResultText: 'Agree with resolution',
    confirmPlatformRuling: 'Request platform arbitration?',
    platformRulingText: 'Request Arbitration',
    policy: 'Cancellation and Rescheduling Policy'
  },
  addClass: {
    addCourse: 'Add Course',
    type: 'Type',
    pleaseSelect: 'Please select',
    courseName: 'Course Name',
    classNumber: 'Number of Classes',
    discount: 'Discount',
    teacherEarningsPerClass: 'Teacher Earnings/Class',
    displayPricePerClass: 'Display Price/Class',
    noDiscount: 'None',
    referenceMarketValue: 'Market reference: Minimum {currency}$80 for 50-minute classes',
    cancel: 'Cancel',
    save: 'Save',
    confirmCancel: 'Confirm cancellation?',
    saveSuccess: 'Saved successfully',
    popular: 'Popular'
  },
  classManage: {
    currentLevel: 'Current Level',
    upgrade: '{hour} hours until next level upgrade',
    viewCommissionRatio: 'View Commission Rate',
    priceAdjustmentNotice: 'Price Adjustment Notice',
    setClassTypeAndPrice: 'Set Class Type and Price',
    trialClass: 'Trial Class',
    oneClass25Minutes: '1 class (25 mins)',
    save: 'Save',
    addCourse: ' + Add Course',
    confirmDelete: 'Confirm deletion?',
    deleteCourse: 'Delete Course',
    submitSuccess: 'Submitted successfully, awaiting review',
    operationSuccess: 'Operation successful',
    cancel: 'Cancel',
    effectiveTime: 'Effective Time',
    revokeModifications: 'Revoke Changes',
    setPrice: 'Set Price'
  },
  myClassTeacher: {
    myClassroom: 'My Classes',
    waitingStudentConfirm: 'Awaiting Student Confirmation',
    startingToday: 'Starting Today',
    waitingMyConfirm: 'Awaiting My Confirmation',
    futureClassroom: 'Future Classes',
    completed: 'Completed',
    exception: 'Exception',
    confirmCancel: 'Confirm cancellation?',
    submitSuccess: 'Submitted successfully',
    operationSuccess: 'Operation successful',
    contactTools: 'Contact Methods'
  },
  myStudents: {
    onCampusStudents: 'Current Students',
    archivedStudents: 'Archived Students',
    student: 'Student',
    learnedCourse: 'Courses Taken',
    prepaidBalance: 'Prepaid Balance',
    remainingBalance: 'Remaining Balance',
    woXueZhiReport: 'WoXueZhi Report',
    communication: 'Communication',
    appointmentClass: 'Book Class',
    learningReport: 'Learning Report',
    pleaseFill: 'Please fill',
    operationSuccess: 'Operation successful',
    confirm: 'Confirm',
    cancel: 'Cancel',
    classHour: 'Class Hours'
  },
  resolved: {
    title: 'Resolved',
    solutionInfo: 'Select agreed solution for student confirmation within 48 hours',
    selectSolution: '*Select resolution',
    pleaseSelect: 'Please select',
    none: 'None',
    courseCompleted: 'Course Completed',
    returnOnce: 'Return One Class',
    partialRefund: 'Partial Refund',
    fillRefundAmount: '*Enter refund amount',
    feeInfo: 'Refund deducted from class fee before commission',
    confirm: 'Confirm',
    cancel: 'Cancel',
    confirmResolve: 'Confirm resolution?',
    resolveText: 'Resolve',
    operationSuccess: 'Operation successful'
  },
  schedule: {
    teachingTime: 'Teaching Schedule',
    availableTeachingTime: 'Available Teaching Times',
    addTimeSlot: '+Add Time Slot',
    generatedTeachingTime: 'Generated Teaching Times:',
    effectiveDate: 'Effective Date',
    always: 'Always',
    until: 'Until',
    save: 'Save',
    confirmDelete: 'Confirm deletion?'
  },
  statistics: {
    total: 'Total',
    netIncomeTotal: 'Total Net Income',
    unparticipatedTrials: 'Unparticipated Trials',
    tutoringHours: 'Tutoring Hours',
    averageRating: 'Average Rating',
    totalRatings: 'Total Ratings',
    totalStudents: 'Total Students',
    averageClassRating: 'Average Class Rating',
    allCoursesStudentAvgRating: 'Average Student Rating Across All Courses',
    hoursPerStudent: 'Hours Per Student',
    calculationMethod: 'Calculated by dividing your tutoring hours by total students',
    attendanceStatus: 'Attendance Status',
    annualPerformanceLast365Days: 'Annual Performance (Last 365 days, updated {date})',
    profileViews: 'Profile Views',
    studentConversionRate: 'Student Conversion Rate',
    effectiveClassHours: 'Effective Teaching Hours',
    hourlyRate: 'Hourly Rate',
    newStudents: 'New Students',
    activeStudents: 'Active Students',
    classHoursPerActiveStudent: 'Classes Per Active Student',
    trialClassRating: 'Trial Class Rating',
    allTime: 'All Time',
    thisMonth: 'This Month',
    thisWeek: 'This Week',
    downloadIncomeReport: 'Download Income Report'
  },
  teacherSet: {
    teacherAccountSetting: 'Teacher Account Settings',
    cloaking: 'Invisible',
    uncloaking: 'Visible',
    setToCloaking: 'Set as Invisible',
    cancelCloaking: 'Cancel Invisible',
    teacherInfo: 'Teacher Profile',
    avatar: 'Avatar',
    name: 'Name',
    surname: 'Surname',
    speakLanguages: 'Languages Spoken (Multiple)',
    select: 'Please select',
    level: 'Level',
    professorLevel: 'Professor Level',
    specialEducationExperience: 'Special Education Experience',
    educationBackground: 'Education',
    certificate: 'Certificates',
    synopsis: 'Brief Introduction',
    selfIntroduction: 'Self Introduction',
    imageIntroduction: 'Image Introduction',
    video: 'Video',
    uploadVideo: 'Upload Video',
    inputYoutubeLink: 'Please enter Paypal account',
    inputzhuanshukuai: 'Please enter FPS account',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    dataUnderReview: 'Data under review, please don\'t resubmit...',
    paymentMethod: 'Payment Method',
    paypal: 'Paypal',
    zhuanshukuai: 'FPS',
    contactTools: 'Contact Methods',
    zoom: 'Zoom',
    meetingLink: 'Meeting Link',
    personalMeetingNumber: 'Personal Meeting ID (PMI)',
    meetingRoomPassword: 'Meeting Room Password',
    voov: 'VOOV',
    submitSuccess: 'Submitted successfully'
  },
  unresolved: {
    platformProcessing: 'After submitting unresolved request, platform will process',
    unresolved: 'Unresolved'
  },
  viewCommission: {
    commissionRatio: 'Commission Rate',
    level: 'Level',
    hours: 'Hours',
    mtExtraction: 'MT Commission',
    classCalculationNote: '50-minute class counts as 1 hour (trial classes excluded)',
    gotIt: 'Got it'
  },
  wallet: {
    myWalletTeacher: 'My Wallet (Teacher)',
    withdraw: 'Withdraw',
    availableBalance: 'Available Balance',
    totalBalance: 'Total Balance',
    pendingBalance: 'Pending Balance',
    approximateAmountNote: '*Amounts approximate and subject to exchange rates. All amounts in USD',
    walletTransactionDetails: 'Wallet Transactions',
    withdrawalDetails: 'Withdrawal Details',
    time: 'Time',
    item: 'Item',
    amount: 'Amount ({currency})',
    courseId: 'Course ID',
    status: 'Status',
    cancelWithdrawal: 'Cancel Withdrawal',
    myWalletTutor: 'My Wallet (Teacher)',
    transferToStudentWallet: 'Transfer to Student Wallet',
    withdrawFromInternalAccount: 'Withdraw from Internal Account',
    transferMethod: 'Transfer Method',
    paypal: 'Paypal',
    fps: 'FPS',
    email: 'Email',
    enter: 'Please enter',
    withdrawAmount: 'Withdrawal Amount',
    maxWithdraw: 'Maximum withdrawal: {amount}{currency}',
    cancel: 'Cancel',
    withdrawProfit: 'Withdraw Earnings',
    transferToStudent: 'Transfer to Student Wallet',
    confirm: 'Confirm',
    operationSuccess: 'Operation successful',
    confirmCancel: 'Confirm cancellation?'
  },
  becomeTeacher: {
    becomeTeacher: 'Become a Teacher',
    fillPersonalInfo: '1 Personal Information',
    uploadPhoto: '2 Upload Photo',
    uploadCertificate: '3 Upload Certificates',
    fillEducation: '4 Education Background',
    fillIntroduction: '5 Self Introduction',
    uploadVideo: '6 Upload Video',
    fillTeachingTime: '7 Teaching Schedule',
    fillTuition: '8 Set Tuition',
    startCreateProfile: 'Start creating your public teacher profile. Your progress saves automatically. You can return anytime',
    name: 'Name',
    pleaseFill: 'Please fill',
    surname: 'Surname',
    speakLanguages: 'Languages Spoken (Multiple)',
    level: 'Level',
    professorLevel: 'Professor Level',
    specialEducationExperience: 'Special Education Experience',
    nextStep: 'Next',
    photo: 'Photo',
    previousStep: 'Previous',
    certificate: 'Certificates',
    education: 'Education',
    synopsis: 'Brief Introduction',
    selfIntroduction: 'Self Introduction',
    imageIntroduction: 'Image Introduction',
    inputYoutubeLink: 'Enter YouTube Link',
    confirm: 'Confirm',
    teachingTime: 'Teaching Schedule',
    availableTeachingTime: 'Available Teaching Times',
    addTimeSlot: '+Add Time Slot',
    generatedTeachingTime: 'Generated Teaching Times:',
    effectiveDate: 'Effective Date',
    always: 'Always',
    until: 'Until',
    setClassTypeAndPrice: 'Set Class Type and Price',
    viewCommissionRatio: 'View Commission Rate',
    trialClass: 'Trial Class',
    one25MinClass: '1 class (25 mins)',
    formalClass: 'Regular Class',
    addCourse: '+ Add Course',
    submit: 'Submit',
    submitSuccess: 'Submitted successfully, awaiting review',
    hint1: 'Please enter name',
    hint2: 'Please enter surname',
    hint3: 'Please select languages and levels',
    hint4: 'Please select professor level',
    hint5: 'Please select special education experience'
  },
  teacherIndex: {
    teacherCenter: 'Teacher Center',
    myClass: 'My Classes',
    myStudents: 'My Students',
    classManagement: 'Class Management',
    schedule: 'Schedule',
    statistics: 'Statistics',
    wallet: 'Wallet',
    settings: 'Settings'
  },
  statusConfirms: {
    appointmentCourse: 'Book Class',
    teacher: 'Teacher',
    coursePackage: 'Class Package',
    remainingClasses: 'Remaining Classes',
    selectContactTool: 'Select teacher\'s contact method',
    contactTool: 'Contact Method',
    nextStep: 'Next',
    confirmReservation: 'Confirm Booking',
    cancel: 'Cancel',
    confirm: 'Confirm',
    selectContactWay: 'Select contact method',
    reservationSuccess: 'Booking Successful',
    week: 'Week',
    hoursFormat: '{start} / {end}',
    classId: 'Class ID:',
    courseName: 'Course Name',
    language: 'Language',
    duration: 'Duration',
    price: 'Price',
    languageCategory: 'Language Category',
    languageType: 'Language Type',
    breakNote: 'Some teachers may include 5-minute breaks',
    contactToolSection: 'Contact Method',
    meetingId: 'Meeting ID',
    password: 'Password',
    teacherEntryTime: 'Teacher entry time:',
    studentEntryTime: 'Student entry time:',
    notes: 'Notes',
    uploadNotes: 'Upload Notes',
    homework: 'Homework',
    uploadHomework: 'Upload Homework',
    test: 'Test',
    uploadTest: 'Upload Test',
    waitingStudentConfirmClass: 'Your class awaiting student confirmation',
    waitingStudentConfirm: 'Awaiting Student Confirmation',
    waitingConfirm: 'Pending Confirmation',
    waitingClass: 'Upcoming Class',
    classCompletedConfirm: 'Completed - Pending Confirmation',
    classCompleted: 'Completed',
    classNotCompleted: 'Class Processed',
    studentConfirm: 'Student has 3 days to confirm, otherwise auto-confirms at {finish_time} ({timeZone})',
    studentMarkedNotCompleted: 'Student marked incomplete, please process before {time} ({timeZone})',
    notCompletedReason: 'Reason: {reason}, Expected: {expectedResult}',
    content: '{content}',
    resolved: 'Resolved',
    unresolved: 'Unresolved',
    waitingPlatformDecision: 'Waiting for Platform Decision',
    confirmCourse: 'Confirm Class',
    cancelClass: 'Cancel Class',
    enterClassroom: 'Enter Classroom',
    reenterNote: 'Click again if interrupted',
    accomplishCourse: 'Confirm Completion',
    courseNotCompleted: 'Class Not Completed',
    confirmCancel: 'Confirm cancellation?',
    operationSuccess: 'Operation successful',
    cancelAndReschedulePolicy: 'Cancellation and Rescheduling Policy',
    teacherhandlingplan: 'Teacher\'s Solution',
    refundAmount: 'Refund Amount',
    processWithin48Hours: 'Awaiting student confirmation before {time}({timeZone})',
    result1: 'Course Completed',
    result2: 'Return One Class',
    result3: 'Partial Refund'
  },
  classTime: {
    selectCourseStartTime: 'Select class start time ({timeZone})',
    obtained: 'Obtained',
    noCourse: 'No courses'
  },
  introductionTeacher: {
    introduceTeacher: 'Introduce Teacher',
    recommendTeacherTip: 'Enter recommended teacher\'s email. If approved, their hours will count toward yours for first 3 months',
    recommendTeacher: 'Recommend Teacher',
    inputTeacherEmail: 'Enter teacher\'s email',
    confirm: 'Confirm',
    recommendedTeachers: 'Recommended Teachers',
    pendingReview: 'Pending Review',
    close: 'Close',
    operationSuccess: 'Operation successful'
  },
  recharge: {
    recharge: 'Top Up',
    rechargeAmount: 'Top Up Amount',
    inputPrompt: 'Please enter',
    thirdPartyFee: 'Third-party fee (non-refundable) + 5%',
    totalPrice: 'Total Price',
    cancel: 'Cancel',
    submit: 'Submit',
    confirmRecharge: 'Confirm top up?',
    rechargeBalance: 'Top Up Balance',
    rechargeSuccess: 'Top Up Successful'
  }
}